// extracted by mini-css-extract-plugin
export default {"catalogLoader":"c-a_i"};